import { render } from "./OrgStructureManagement.vue?vue&type=template&id=7061a197&scoped=true"
import script from "./OrgStructureManagement.vue?vue&type=script&lang=js"
export * from "./OrgStructureManagement.vue?vue&type=script&lang=js"

import "./OrgStructureManagement.vue?vue&type=style&index=0&id=7061a197&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7061a197"]])

export default __exports__